export default __webpack_public_path__ + "static/media/Website-02.74cf4337.png";